export default __webpack_public_path__ + "static/media/share_fb_es.1bc27844.gif";